import { AuthService } from './../authentication/auth.service';
import { collection, getDocs, Timestamp, Firestore, onSnapshot, getFirestore} from 'firebase/firestore';
import { Injectable } from '@angular/core';
import { StripeSubscription, SubscriptionStatus } from 'src/app/model/stripe.models';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StripeService {

  private _subscriptions: StripeSubscription[] = [];
  //private _currentSubscription: StripeSubscription = null;

  // (1) Keep the last value
  private _currentSubscription = new ReplaySubject<StripeSubscription | null>(1);

  private _currentSubscritpionStatus: SubscriptionStatus = SubscriptionStatus.INDETERMINATE;

  private firestore: Firestore = getFirestore();

  constructor(private authService: AuthService) {
    const userSubscription = this.authService.user$.subscribe(user => {

      if (user) {
        this.initializeSubscriptionListener(user.uid);
        userSubscription.unsubscribe();
      }
    });
  }

  // Method to access the current subscription status
  get currentSubscriptionStatus(): SubscriptionStatus {
    return this._currentSubscritpionStatus;
  }

  // Método para atualizar a subscrição atual
  updateCurrentSubscription(subscription: StripeSubscription | null): void {
    this._currentSubscritpionStatus = subscription ? subscription.status : SubscriptionStatus.INDETERMINATE;
    this._currentSubscription.next(subscription);
  }

  // Método público para acessar o ReplaySubject como um Observable
  get currentSubscription$(): Observable<StripeSubscription | null> {
    return this._currentSubscription.asObservable();
  }

  /**
   * Initializes the subscription listener for a given user.
   * @param userId The ID of the user.
   */
  initializeSubscriptionListener(userId: string): void {
    const subscriptionsPath = `customers/${userId}/subscriptions`;
    const subscriptionsCollectionRef = collection(this.firestore, subscriptionsPath);

    // Listen for changes in the subscriptions collection
    onSnapshot(subscriptionsCollectionRef, (querySnapshot) => {

      let currentSubscriptionTemp: StripeSubscription = null;

      // Map the query snapshot to an array of StripeSubscription objects
      this._subscriptions = querySnapshot.docs.map(doc => {
        const data = doc.data();

        return {
          id: doc.id,
          cancel_at: data.cancel_at ? (data.cancel_at as Timestamp).toDate() : null,
          cancel_at_period_end: data.cancel_at_period_end,
          current_period_end: data.current_period_end ? (data.current_period_end as Timestamp).toDate() : null,
          current_period_start: data.current_period_start ? (data.current_period_start as Timestamp).toDate() : null,
          ended_at: data.ended_at ? (data.ended_at as Timestamp).toDate() : null,
          status: data.status,
          trial_end: data.trial_end ? (data.trial_end as Timestamp).toDate() : null,
          trial_start: data.trial_start ? (data.trial_start as Timestamp).toDate() : null,
          items: data.items,
          // other fields as needed
        } as StripeSubscription;
      });

      // Determine the current subscription based on status and cancellation period
      currentSubscriptionTemp = this._subscriptions.find(s => (s.status === SubscriptionStatus.ACTIVE) && (!s.cancel_at_period_end));

      if (!currentSubscriptionTemp) {
        currentSubscriptionTemp = this._subscriptions.find(s => s.status ===  (SubscriptionStatus.TRIALING) && (!s.cancel_at_period_end));
      }

      if (!currentSubscriptionTemp) {
        currentSubscriptionTemp = this._subscriptions.find(s => s.status === SubscriptionStatus.ACTIVE);
      }

      if (!currentSubscriptionTemp) {
        currentSubscriptionTemp = this._subscriptions.find(s => s.status === SubscriptionStatus.TRIALING);
      }

      if (!currentSubscriptionTemp) {
        //currentSubscription = this._subscriptions.find(s => s.status === 'canceled');
        // If no current subscription is found, use the first subscription in the array (if available)
        currentSubscriptionTemp = this._subscriptions[0] ? this._subscriptions[0] : null;
      }

      // Update the current subscription
      this.updateCurrentSubscription(currentSubscriptionTemp);
    });
  }

  // Method to access subscriptions
  get subscriptions(): StripeSubscription[] {
    return this._subscriptions;
  }

  hasTrial() {
    return this._currentSubscritpionStatus === SubscriptionStatus.INDETERMINATE;
  }

  // not used
  async getSubscriptionsForCurrentUser(userId: string): Promise<StripeSubscription[]> {

    const subscriptionsPath = `customers/${userId}/subscriptions`;
    const subscriptionsCollectionRef = collection(this.firestore, subscriptionsPath);
   // const q = query(subscriptionsCollectionRef, where('userId', '==', userId));

    const querySnapshot = await getDocs(subscriptionsCollectionRef);
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    })) as StripeSubscription[];
  }


}
